<template>
  <div class="page">
    <h1 class="text-h3 mb-4">
      {{ $t("diagnosis.title") }}
      <div class="subtitle-1" v-if="list">
        <span class="grey--text mb-2">Total: </span>
        <span class="font-weight-medium">{{ list.length }}</span>
      </div>
    </h1>

    <v-alert type="info" v-if="allSlidesAnnotated === true">
      {{ $t("diagnosis.table.allFinished") }}
    </v-alert>
    <v-alert type="warning" v-if="allSlidesAnnotated === false">
      {{ $t("diagnosis.table.notFinished") }}
    </v-alert>

    <v-btn @click="onClickStart" v-if="list && list.length > 0">{{ $t("button.start") }}</v-btn>
    <v-data-table
      v-if="list"
      :class="{ table: !loading }"
      :items="list"
      :headers="selectedHeaders"
      :loading="loading"
      :loading-text="$t('diagnosis.table.searchingSlides')"
      :no-data-text="$t('diagnosis.table.noSlides')"
      @click:row="onClickRow"
    >
      <template v-slot:item.projectName="{ item }">
        <span v-if="project(item.project)">
          {{ project(item.project).project_name }}
        </span>
      </template>

      <!-- <template v-slot:item.projectDetails="{ item }">
        <span v-if="project(item.project)">
          {{ project(item.project).details | truncate }}
        </span>
      </template> -->

      <template v-slot:item.annotationClasses="{ item }">
        {{ getAnnotationClasses(item).split(", ").map(x => $t("report." + x.toLowerCase())).join(", ") }}
      </template>

      <template v-slot:item.diagnosis="{ item }">
        <div v-if="item.diagnosis">
          {{ item.diagnosis.length > 0 ? $t("report." + item.diagnosis[0].annotation_class.class_name.toLowerCase()) : $t('diagnosis.visualization.pending') }}
          <!-- {{ item.slide }} -->
        </div>
        <!-- <div
          v-else
        >
          Pending
        </div> -->
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { FIND } from "@/store/modules/project";
import { FIND as FIND_ANNOTATION_CLASS } from "@/store/modules/annotationClass";
import {
  ANNOTATE_NEXT,
  CURRENT_SLIDE,
  LOAD_SLIDES_WITH_DIAGNOSIS,
  SET_CURRENT_INDEX
} from "@/store/modules/annotation";
import { LIST } from "@/store/modules/annotation";

export default {
  data() {
    return {
      slidesWithDiagnosis: [],
    };
  },
  computed: {
    ...mapState({
      token: state => state.authentication.keycloak.token,
      loading: state => state.annotation.loading
    }),
    ...mapGetters({
      list: LIST,
      project: FIND,
      annotationClass: FIND_ANNOTATION_CLASS
    }),
    selectedHeaders() {
      return this.headers;
    },
    allSlidesAnnotated() {
      return this.$route.query.status;
    },
    headers() {
      return [
        {
          text: this.$t("diagnosis.table.id"),
          value: "id"
        },
        {
          text: this.$t("diagnosis.table.project"),
          value: "projectName"
        },
        // {
        //   text: this.$t("diagnosis.table.description"),
        //   value: "projectDetails"
        // },
        {
          text: this.$t("diagnosis.table.lookingFor"),
          value: "annotationClasses"
        },
        {
          text: this.$t("diagnosis.table.diagnosis"),
          value: "diagnosis"
        }
      ]
    },
  },
  methods: {
    itemClass(slide) {
      if (slide.diagnosis)
        return slide.diagnosis.annotation_class.class_name.toLowerCase()
      return null
    },
    getStatusHumanReadable(item) {
      switch(item.status) {
        case "assigned": return "Assigned"
        case "annotated": return "Annotated"
        case "annotations_requested": return "Annotation Requested"
        default: return "undefined"
      }
    },
    getAnnotationClasses(item) {
      const annotationClasses = item.annotation_class
        .map(x => this.annotationClass(x))
        .map(x => x.class_name)
        .join(", ");
      console.log("getting annotation classes:")
      console.log(item.annotation_class)
      console.log(annotationClasses)
      return annotationClasses
    },
    onClickRow(slide) {
      const index = this.$store.state.annotation.allIds.indexOf(
        slide.id.toString()
      );
      this.$store.commit(SET_CURRENT_INDEX, index);
      this.goToSlide(slide);
    },
    onClickStart() {
      this.$store.dispatch(ANNOTATE_NEXT);
      this.goToSlide(this.$store.getters[CURRENT_SLIDE]);
    },
    goToSlide(slide) {
      this.$router.push({
        name: "diagnose-visualize",
        params: { id: slide.id }
      });
    }
  },
  async created() {
    this.$store.dispatch(LOAD_SLIDES_WITH_DIAGNOSIS);
  }
};
</script>

<style lang="scss" scoped>
</style>
